module.exports = __webpack_public_path__ + "static/media/background_landing.404db8de.png";